import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';

/**
 * 构建群组详情页 URL，确保包含正确的 basePath
 * 正确格式示例：http://localhost/community_backup/public/groups/93
 */
function getGroupDetailUrl(groupId) {
  const baseUrl = (app.forum.attribute('baseUrl') || '').replace(/\/$/, '');
  return baseUrl + '/groups/' + groupId;
}

/**
 * 详情页 PostStream 区域的面包屑导航
 * 结构：Home (图标) > [群组] > [分类标签] > 讨论标题
 */
export default class PostStreamBreadcrumb extends Component {
  view() {
    const discussion = this.attrs.discussion;
    if (!discussion) return null;

    // 获取群组信息（从 discussion 的 social_group 属性）
    const group = discussion.attribute && discussion.attribute('social_group');


    const separator = <span className="PostStreamBreadcrumb-separator">{' > '}</span>;

    return (
      <nav className="PostStreamBreadcrumb" aria-label={app.translator.trans('tf-custom-discussions-details.forum.breadcrumb_home')}>
        <Link href={app.route('index')} className="PostStreamBreadcrumb-home">
          <i className="fa-solid fa-house"></i>
          <span>{app.translator.trans('tf-custom-discussions-details.forum.breadcrumb_home')}</span>
        </Link>
        {group && (
          <>
            {separator}
            <Link href={getGroupDetailUrl(group.id)} className="PostStreamBreadcrumb-group">
              {group.name}
            </Link>
          </>
        )}
        {separator}
        <span className="PostStreamBreadcrumb-current">{discussion.title()}</span>
      </nav>
    );
  }
}
